(function() {
    function getSectionsToRender() {
        return [
          {
            selector: 'js-main-product',
            sectionId: document.querySelector('[js-main-product]')?.dataset.section
          },
          {
            selector: 'js-related-products',
            sectionId: document.querySelector('[js-related-products]')?.dataset.sectionId
          }
           
        ];
    };    

    function renderSections(handle) {
         console.log({ handle })
        getSectionsToRender().forEach(section => {
            fetch(`/products/${handle}?section_id=${section.sectionId}`)
            .then( response => response.text())
            .then(html => {
                const prevSelectedVariantValue = document.querySelector(".product-options-grid input:checked").value
                const doc = new DOMParser().parseFromString(html, 'text/html');
                
                const elementToReplace = document.querySelector(`[${section.selector}]`);
                if(elementToReplace) {
                    elementToReplace.innerHTML = doc.querySelector(`[${section.selector}]`) ? doc.querySelector(`[${section.selector}]`).innerHTML : '';
                };
               const allVariants = elementToReplace.querySelectorAll(".product-options-grid input")
               allVariants.forEach( variant => {
                   if(prevSelectedVariantValue == variant.value ){
                       console.log(variant.nextElementSibling)
                       variant.nextElementSibling.click()
                   }
               });
                if(section.selector === 'js-main-product') {
                    document.dispatchEvent(new CustomEvent("size-chart:init"));
                    document.dispatchEvent(new CustomEvent("size-chart-parameters:init"));
                    // document.dispatchEvent(new CustomEvent("junipReview:init"));
                    document.dispatchEvent(new CustomEvent('clipboardEvent'));

                    bootstrapSizeNFitComWidgetAuto();
                    document.dispatchEvent(new CustomEvent('observe-size-n-fit:init'));

                if(document.querySelector('[js-product-modal]')) {
                    document.querySelector('[js-product-modal]').innerHTML = doc.querySelector(`[js-product-modal]`) ? doc.querySelector(`[js-product-modal]`).innerHTML : '';
                };
                  
                }else if(section.selector === 'js-related-products') {
                    document.dispatchEvent(new CustomEvent("product-recommendations:init"));
                }
              
               
            })
            .catch(function(error) {
                console.log(error);
            });
        });
    };

    class productSwatches extends HTMLElement {
        constructor() {
            super();

            console.log('testing ...')
        
            this.selectors = {
                swatchItem: "[js-swatch-item]",
                swatchHandle: "[js-swatch-handle]"
            };
    
            this.classes = {
                activeClass: 'active'
            }
    
            this.swatchItems = this.querySelectorAll(this.selectors.swatchItem);
            this.swatchHandle = this.querySelector(this.selectors.swatchHandle);
            
            this.init();
        };
    
        init() {
          

           //===========new
              if(this.querySelectorAll("[js-swatch-item][data-solid-item]:not(.hidden)").length == 0) {
                   if(document.querySelector('[data-solid-label]') != null) {
                     document.querySelector('[data-solid-label]').classList.add('hidden');
                   }
              }
              else {
                 if(document.querySelector('[data-solid-label]') != null) {
                     document.querySelector('[data-solid-label]').classList.remove('hidden');
                 }
              }
              if(this.querySelectorAll("[js-swatch-item][data-print-item]:not(.hidden)").length == 0) {
                 if(document.querySelector('[data-print-label]') != null) {
                     document.querySelector('[data-print-label]').classList.add('hidden');
                 }
              }
              else {
                 if(document.querySelector('[data-print-label]') != null) {
                     document.querySelector('[data-print-label]').classList.remove('hidden');
                 }
              }
          
            this.swatchItems.forEach( swatchItem => {
                swatchItem.addEventListener('click', ({currentTarget}) => {
                    this.toggleProduct(currentTarget);
                    
                })
            });
        };
        
      
        toggleProduct(targetProduct) {
            console.log({ targetProduct })
            const productHandle = targetProduct.dataset.productHandle;
            const swatchHandle = targetProduct.dataset.swatchHandle;
            this.updateState(targetProduct);
            this.updateHistoryState(productHandle);
            renderSections(productHandle);
            
        };
    
        updateState(targetEl) {
            document.body.classList.add("disabled");
            this.swatchItems.forEach( item => item.classList.remove(this.classes.activeClass));
            targetEl.classList.add(this.classes.activeClass);
        };
    
        updateHistoryState(handle) {
            var newurl = `${window.location.protocol}//${window.location.host}/products/${handle}`;
            window.history.pushState({path: newurl}, '', newurl);
        };
    }
      
    customElements.define('product-swatches', productSwatches);
})()